import { render, staticRenderFns } from "./RegistredPage.vue?vue&type=template&id=2e6a7720&scoped=true"
import script from "./RegistredPage.vue?vue&type=script&lang=js"
export * from "./RegistredPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6a7720",
  null
  
)

export default component.exports